import React from 'react'
import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { Coverage } from '../core/types'
import { nf } from '../core/consts'
import { METRIC_HINTS } from '../core/hints'
import { useChartTheme } from '../core/chartTheme'
import InfoHint from '../../../../../common/InfoHint'

type Props = {
  coverage: Coverage
  currency: string
}

const CoverageRing: React.FC<Props> = ({ coverage, currency }) => {
  const theme = useChartTheme()
  const pct = Math.round(coverage.coverage_pct)
  const color = pct >= 80 ? '#50CD89' : pct >= 50 ? '#FFC700' : '#F1416C'

  const options: ApexOptions = {
    chart: { type: 'radialBar', background: 'transparent' },
    theme: { mode: theme.mode },
    colors: [color],
    plotOptions: {
      radialBar: {
        hollow: { size: '60%' },
        track: { background: theme.gridColor },
        dataLabels: {
          name: { show: true, offsetY: 20, color: '#7E8299', fontSize: '13px' },
          value: {
            show: true,
            offsetY: -15,
            fontSize: '28px',
            fontWeight: 700,
            formatter: (v) => `${Math.round(v)}%`,
          },
        },
      },
    },
    labels: ['Покрытие спроса'],
  }

  return (
    <div className='card h-100'>
      <div className='card-header'>
        <h3 className='card-title d-inline-flex align-items-center'>
          Покрытие спроса по сумме ({currency})
          <InfoHint text={METRIC_HINTS.coverage_ring} />
        </h3>
      </div>
      <div className='card-body d-flex flex-column align-items-center justify-content-center'>
        {coverage.demand_zero ? (
          <div className='text-center py-10'>
            <div className='fs-2 fw-bold text-muted'>Нет спроса</div>
            <div className='text-muted fs-8 mt-2'>активных депозитов в ожидании нет</div>
          </div>
        ) : (
          <>
            <Chart options={options} series={[pct]} type='radialBar' height={280} />
            <div className='text-gray-700 fs-8 text-center'>
              остаток выплат {nf.format(coverage.payout_remainder)} {currency} · спрос{' '}
              {nf.format(coverage.deposit_demand)} {currency}
              <br />
              по сумме; реальную принимаемость см. KPI «Принимаемость спроса»
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default CoverageRing
